module.exports = __webpack_public_path__ + "img/sampdoria-logo-icon.4c99e497.png";